import { render, staticRenderFns } from "./event-item-group.vue?vue&type=template&id=0a7053ee&scoped=true&"
import script from "./event-item-group.vue?vue&type=script&lang=js&"
export * from "./event-item-group.vue?vue&type=script&lang=js&"
import style0 from "./event-item-group.vue?vue&type=style&index=0&id=0a7053ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7053ee",
  null
  
)

export default component.exports